<div class="flex flex-col h-full overflow-hidden">
  <div class="z-50 bg-white">
    <app-header />
  </div>

  @if ((appState$ | async)?.isMobileMenuOpened) {
    <app-mobile-menu />
  }

  <div #contentContainer class="flex-1 overflow-y-auto">
    <div class="flex flex-row min-h-[calc(100vh-60px)]">
      <div class="flex-1">
        <router-outlet />
      </div>
    </div>

    <app-footer />
  </div>
</div>
